import { createFileRoute } from '@tanstack/react-router'
import { ChatsPage } from '@/features/storefront-chat/chats-page'

export const Route = createFileRoute('/_authenticated/customer-comms/chats/')({
  staticData: { title: 'Chats' },
  component: () => <ChatsPage />,
})
